


















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class VisitsEvolutionVisitorsTable extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  items = [];
  dates = [];

  headers = [];

  mounted() {
    this.load();
  }

  load() {
    let map = new Map();
    let dates = new Set<string>();
    let names = new Set<string>();

    this.kpis.forEach((i) => {
      if (!map[i.descPeriodo]) {
        map[i.descPeriodo] = [];
      }
      if (!map[i.descPeriodo][i.nome]) {
        map[i.descPeriodo][i.nome] = [];
      }
      map[i.descPeriodo][i.nome] = i.realizadas;
      map[i.descPeriodo]['meta'] = i.meta;
      dates.add(i.descPeriodo);
      names.add(i.nome);
    });

    let headers = [];
    this.headers = headers;
    headers.push({ text: 'Consultor', value: 'nome' });
    dates.forEach((d) => {
      headers.push({ text: d, value: "valores['" + d + "']", sortable: false });
    });

    this.items = [];
    names.forEach((n) => {
      let values = new Map();
      let percents = new Map();
      let previousDay = null;
      dates.forEach((d) => {
        values[d] = map[d][n];
        percents[d] = this.calcGrowth(values[previousDay], values[d]);
        previousDay = d;
      });
      this.items.push({
        nome: n,
        valores: values,
        percents: percents
      });
    });

    this.dates = Array.from(dates);
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  calcGrowth(v1, v2) {
    if (!v1) {
      return null;
    }
    if (!v2) {
      v2 = 0;
    }
    if (v1 == v2) {
      return 0;
    }
    return Math.round((v2 / v1 - 1) * 100);
  }
}
